import {
  Image,
  Input,
  Box,
  Container,
  Button,
  HeadingProps,
  Heading,
  Label,
  Paragraph,
  Select,
} from '@apia/theme';

const TagReplacers = {
  div: Box,
  button: Button,
  container: Container,
  h1: (props: HeadingProps) => <Heading as="h1" {...props} />,
  h2: (props: HeadingProps) => <Heading as="h2" {...props} />,
  h3: (props: HeadingProps) => <Heading as="h3" {...props} />,
  h4: (props: HeadingProps) => <Heading as="h4" {...props} />,
  h5: (props: HeadingProps) => <Heading as="h5" {...props} />,
  h6: (props: HeadingProps) => <Heading as="h6" {...props} />,
  img: Image,
  label: Label,
  input: Input,
  p: Paragraph,
  select: Select,
};

export default TagReplacers;
